<template>
  <form @submit.prevent="onSubmit">
    <p class="text-sm leading-snug md:text-base text-sn-gray-900">
      {{ tr('pages.sales.checkout.form.payment.cardholder.description') }}
    </p>
    <div class="flex flex-col md:items-start md:flex-row md:justify-between pt-3">
      <TextInput
        v-model.trim="name"
        :disabled="locked"
        :label="tr('pages.sales.checkout.form.payment.cardholder.name')"
        :placeholder="tr('pages.sales.checkout.form.payment.cardholder.name')"
        extra-class="w-full mb-4 md:w-1/2 md:mr-4 xl:mb-6"
        :error="$v.name.$error ? tr('errors.type.required') : ''"
        @change="nameDirty = true"
      />

      <TextInput
        v-model.trim="email"
        :disabled="locked"
        :label="tr('pages.sales.checkout.form.payment.cardholder.email')"
        :placeholder="tr('pages.sales.checkout.form.payment.cardholder.email')"
        extra-class="w-full mb-4 md:w-1/2 md:mr-4 xl:mb-6"
        :error="emailError"
        @change="emailDirty = true"
      />

      <div class="py-5 md:py-0">
        <Button
          v-if="!locked"
          key="confirm"
          variant="primary"
          type="submit"
        >
          {{ tr('pages.sales.checkout.form.payment.cardholder.confirm') }}
        </Button>
        <Button
          v-if="locked"
          key="unlock"
          variant="secondary"
          type="button"
          class="whitespace-no-wrap"
          @click="$emit('unlock')"
        >
          {{ tr('pages.sales.checkout.form.payment.cardholder.unlock') }}
        </Button>
      </div>
    </div>
  </form>
</template>

<script>
import TextInput from '~brand-components/brussels/shared/text-input.vue'
import Button from '~brand-components/brussels/button/button.vue'
import Card3dsInformationForm from '~brand-components/base/sale/card-3ds-information-form.js'

export default Card3dsInformationForm.extend({
  components: {
    TextInput,
    Button,
  },

})
</script>
